import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'styles/index.css';
import { Spinner } from './components';
import App from './App';

// import { mockEhrRecord } from './data/mockData';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Suspense fallback={<Spinner />}>
    <App />
  </Suspense>
);
